import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgbCollapse, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { WebMonthAttendanceService } from '../Model/WebMonthAttendance/web-month-attendance.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { EditAttendanceComponent } from '../WebMonthAttendance/edit-attendance/edit-attendance.component';
import { ViewSummaryComponent } from '../WebMonthAttendance/view-summary/view-summary.component';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-web-month-attendance-back',
  standalone: true,
  imports: [CommonModule, LoaderComponent, NgbCollapse, FormsModule, NgSelectModule, DataTablesModule, NgbModule],
  templateUrl: './web-month-attendance-back.component.html',
  styleUrl: './web-month-attendance-back.component.scss'
})
export class WebMonthAttendanceBackComponent {

  isDisabled: boolean = false;
  isCollapsed: boolean = false;
  public User: any = null;
  BranchMasterLoad: any[] = []
  TableDatas = [] as any;
  selectedMonthFormatted: any = null;

  Detail = {
    SELECTTYPE: 0,
    MONTHNAME: null,
    YEARNAME: null,
    BRANCHID: null,
    EMPTYPE: 'BACK',
    EMPCODE: null,
    EMPMASTERID: null,
    From: null as any,
    To: null as any,
    FROMDATE: null as any,
    TODATE: null as any
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private toast: ToastService,
    private getmonthattendance: WebMonthAttendanceService,
    private comboload: ComboService,
    public common: CommonService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.ComboLoad('Branch');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Detail.BRANCHID : 0,
      'ClientId': 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMasterLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  onchange(type: string) {
    if (type === 'Date') {
      this.TableDatas = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Branch') {
      this.TableDatas = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }

  EditAttandance(element: any) {
    if (this.common.PageRight.IsView) {
      // const [a, b] = this.selectedMonthFormatted.split(' ');
      const modalRef = this.modalService.open(EditAttendanceComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        MONTHNAME: '',
        YEARNAME: '',
        BRANCHID: this.Detail.BRANCHID,
        // CLIENTID: this.Detail.CLIENTID,
        // SITEID: this.Detail.SITEID,
        EMPTYPE: 'BACK',
        EMPCODE: this.Detail.EMPCODE,
        EMPMASTERID: element.EmpMasterID,
        EmpName: element.FULLNAME,
        Empcode: element.EMPCODE,
        DesignationName: element.DesignationName,
        Photo: element.Photo,
        FROMDATE: this.dateFormat.format(this.Detail.From),
        TODATE: this.dateFormat.format(this.Detail.To)
      };

      modalRef.result.then((result: any) => {
        if (result) {
          this.getData();
        }
      })

    }
  }

  ViewAttandance() {
    if (this.common.PageRight.IsView) {
      const [a, b] = this.selectedMonthFormatted.split(' ');
      const modalRef = this.modalService.open(ViewSummaryComponent, { centered: true, backdrop: 'static', size: 'lg' });
      modalRef.componentInstance.InputData = {
        MONTHNAME: a,
        YEARNAME: b,
        BRANCHID: this.Detail.BRANCHID,
        // CLIENTID: this.Detail.CLIENTID,
        // SITEID: this.Detail.SITEID,
        EMPTYPE: 'BACK',
        EMPCODE: this.Detail.EMPCODE,
        EMPMASTERID: this.Detail.EMPMASTERID,
        EmpName: '',
        Empcode: this.Detail.EMPCODE,
        DesignationName: '',
        Photo: '',
      };
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.getData();
      // const [a, b] = this.selectedMonthFormatted.split(' ');
      // console.log('month ', a, '---', 'year', b)
    } else {
      this.toast.show({ message: "Select all mandatory fields.", type: toastTypeEnum.danger })
      form.submitted = true;
    }
  }

  clearGrid() {
    this.TableDatas = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  getData() {
    this.isDisabled = true;
    // const [a, b] = this.selectedMonthFormatted.split(' ');
    this.Detail.SELECTTYPE = 1
    // this.Detail.MONTHNAME = a
    // this.Detail.YEARNAME = b;
    this.Detail.FROMDATE = this.dateFormat.format(this.Detail.From);
    this.Detail.TODATE = this.dateFormat.format(this.Detail.To);
    this.getmonthattendance.GetMonthlyAttendanceSummary(this.Detail).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table.length == 0) {
            this.toast.show({ message: "No Data Found", type: toastTypeEnum.warning })
          }
          this.TableDatas = Object.values(response.Table);
          this.isDisabled = false;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
